import React, { useEffect, useState, useCallback } from "react";
import { Row, Col, Form, Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { differenceInYears } from "date-fns";

import Users from '../../../../api/Users';
import Events from "../../../../api/Events";
import Products from "../../../../api/Products";

import ErrorCatcher from "../../../../components/common/ErrorCatcher";
import PopUpAlert from "../../../../components/common/PopUpAlert";
import CustomResponseFields from '../../../../components/EventComponents/CustomResponseFields'
import CustomSelectField from "../../../../components/common/CustomSelectField";

import { addToCart } from "../../../../utils/thunks";

import "./Children.scss"

export const Children = ({
        variants=[], 
        allowVariants=true, 
        ...props
    }) => {
    
    let dispatch = useDispatch();
    const history = useHistory();

    const eventID = props.event_id;

    const familyMembers=useSelector(state=>state.family.all_family_no_dupes)
    const [localUser, setLocalUser] = useState();
    const [participants, setParticipants] = useState([]);
    const [selectedParticipant, setSelectedParticipant] = useState();
    const [validated, setValidated] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState();
    const [validationErrors, setValidationErrors]=useState([])
    const [success, setSuccess] = useState();
    const [customFields, setCustomFields] = useState([]);
    const [productID, setProductID] = useState();
    const [needsCart, setNeedsCart]=useState();
    const [variantId, setVariantId]=useState();
    const [loadingParticipants, setLoadingParticipants]=useState(true);
    
    let disabled;
    if(submitting || loadingParticipants) disabled = true;
    else if(typeof(selectedParticipant.allowed) === "string") disabled = true;
    else disabled = false;

    const needPayBlock=(
        <div>
            {productID ?
                <div>   
                    <p>
                        This event requires payment to complete registration! 
                        <br />
                        or press "OK" below to continue and checkout later.  You will not be fully registered for this event until you complete payment.
                    </p>
                    <p className="d-flex justify-content-between"> 
                        <Button onClick={()=>history.push("/p/cart")}>Complete Registration</Button> 
                        <Button onClick={()=>history.push("/p/event-register")} variant="light">OK</Button>
                    </p>
                </div>
                :
                <p>
                    Your registration has been submitted. You should recieve your confirmation email shortly! 
                </p>
            }
        </div>
    )

    const noPaymentBlock=(
        <div>
            <p>
                This event has no registration fee so you should be all set!
            </p>
            {/* <p className="d-flex justify-content-between">
                <Button onClick={()=>history.push('/p/home')}>Home</Button>
            </p> */}
        </div>
    )
//#region callbacks
    const checkAllowedAge =useCallback((user)=>{
        const age = differenceInYears(new Date(), new Date(user.dob));
            let allowed;
            if(props.eventAges.min || props.eventAges.max){
                if(props.eventAges.min && props.eventAges.max){
                    allowed = age >= props.eventAges.min && age <= props.eventAges.max ? true : "Participant is not within the age range";
                }else if(props.eventAges.min){
                    allowed = age >= props.eventAges.min ? true : "Participant is below the age limit";
                }else if(props.eventAges.max){
                    allowed = age <= props.eventAges.max ? true : "Participant is above the age limit";
                }else allowed = true;
            }
            return allowed;
    },[])

    const setParticipantArray=useCallback((response, participantsArray)=>{
        response?.forEach( (user, i) => {
            let allowed = checkAllowedAge(user);
            participantsArray.push({
                key: i + 2,
                name: user.first_name + " " + user.last_name,
                value: {
                    id: user.user_id,
                    first_name: user.first_name,
                    last_name: user.last_name,
                    allowed: allowed
                },
            })
        });
        setParticipants(participantsArray);
        setSelectedParticipant(participantsArray[0].value);
    },[checkAllowedAge])

//#endregion callbacks

//#region useEffects
    useEffect(() => {
        let mounted = true;

        if(eventID){
            Events.getSingle({id: eventID})
            .then( response => {
                if(mounted) {
                    setProductID(response.data[0]?.product_id);
                }else if(mounted && response.errors) setError(<ErrorCatcher error={response.errors} />);
            }).catch(e => console.error(e));

        }

        return () => mounted = false;
    },[eventID]);

    useEffect(()=>{
        if(participants.length > 0) setLoadingParticipants(false)
    },[participants])

    useEffect(() => {
        let mounted = true;

        let participantsArray = [];
        Users.get({})
        .then( response => {
            if(mounted && response.data) {
                setLocalUser(response.data.profile);
                let allowed = checkAllowedAge(response.data.profile);
                participantsArray.push({
                    key: 1,
                    name: response.data.profile.first_name + " " + response.data.profile.last_name + " (Me)",
                    value: {
                        id: response.data.profile.id,
                        first_name: response.data.profile.first_name,
                        last_name: response.data.profile.last_name,
                        allowed: allowed
                    }
                });
                if(familyMembers){
                    setParticipantArray(familyMembers, participantsArray);
                }
            }else if(mounted && response.error){
                setError(<ErrorCatcher error={response.errors} />);
            }
        }).catch(e => console.error(e));

        return () => mounted = false;
    },[familyMembers, setParticipantArray, checkAllowedAge]);
//#endregion useEffects

    
    // form submission
    const submitInfoHandler = async (event) => {

        const form = event.currentTarget;

        event.preventDefault();
        event.stopPropagation();

        setSubmitting(true);

        if(!validated) {
            setSubmitting(false);
            return;
        }
        if (form.checkValidity() === true && validated) {

            setError(null);
            setSuccess(null);

            const formData = new FormData(event.target);
            formData.append("for_user_id", selectedParticipant.id);
            formData.append("by_user_id", localUser.id)
            formData.append("event_id", eventID);
            formData.append("allow_variants", allowVariants); //if false, should only ever use default
            const formDataObj = Object.fromEntries(formData);

            await Users.eventRegister(formDataObj)
            .then( async response => {
                if (!response.errors) {
                    setSubmitting(false);
                    setValidated(false);
                    let price = null;
                    if(productID) {
                        await Products.get({id: productID})
                        .then( response => {
                            // TODO: This has no error handling if the call does not work as intended
                            let item = response.data.products[0];
                            let variant;
                            if(variantId) variant = item.product_variants.filter(v=>v.id===variantId)[0];
                            else variant = item.product_variants[0];
                            price = +variant.price
                            if(price) dispatch(addToCart([{
                                category_id: item.categories[0]?.id,
                                discounts: 0,
                                hash: null,
                                id: item.id,
                                product_type_id: item.product_type_id,
                                is_taxable: item.is_taxable,
                                original_price: +variant.price,
                                parent_id: null,
                                product_name: item.name,
                                product_price: +variant.price,
                                qty: 1,
                                type: 1,
                                variant_id: variant.id,
                                variant_name: variant.name,
                                event: {
                                    event_id: eventID,
                                    for_user_id: selectedParticipant.id
                                }
                            }]));
                        }).catch(e => console.error(e));
                    }
                    setNeedsCart(productID && price > 0 ? true : false)
                    setSuccess(productID && price > 0 ? needPayBlock : noPaymentBlock);
                }
                else if(response.errors) setError(<ErrorCatcher error={response.errors} />);
            }).catch(e => {
                console.error(e);
                setSubmitting(false);
                setError(e);
            });

            setSubmitting(false);
            setValidated(false);
           
        } else setSubmitting(false);
    };

    const selectParticipantHandler = async e => {
        let participant = JSON.parse(e.target.value);
        setSelectedParticipant(participant);
    }

    const handleVariantSelection=(e, variant)=>{
        e.preventDefault();
        setVariantId(parseInt(e.target.value));
    }

    const customFieldValidationHandler=(validated, errors)=>{
        setValidated(validated);
        setValidationErrors(errors)
    }

    return (
        <div>
            <Form noValidate validated={validated} onSubmit={submitInfoHandler} className="input-form" data-cy="register-event-lower-card">
                <PopUpAlert
                    propShow={success ? true : false}
                    goto={success && !needsCart ? "/p/" : "/p/event-register"} 
                    type={"custom"}
                    custom={success && !needsCart ? "success" : "primary"}
                    propTitle={success && !needsCart ? "Success!" : "Almost Done!"}
                    msg={success}
                    backdrop={success && !needsCart ? true : "static"}
                    dismissable={false}
                    hiddenButton={success && true}
                />
                <Row className="mt-5">
                    <h5 className="dash-title" data-cy="register-event-title">Register for this Event</h5>
                    <Col className="p-0 col-auto">
                        {variants && variants?.length > 1 && allowVariants &&
                            <p>
                                <label className="form-label">Event Variant</label>
                                <br />
                                <select onChange={(e)=>{handleVariantSelection(e)}}>
                                    {variants?.map((variant)=>(
                                            <option value={variant.id} key={variant.id}>
                                                {variant?.name} - {variant?.price}
                                            </option>
                                        ))}
                                </select>
                            </p>    
                        }
                    </Col>
                </Row>
                <Row>
                    <label className="form-label">Participant</label>
                    <Col lg="12" data-cy="register-event-participant">
                        {!loadingParticipants ?
                            <Form.Group controlId="participant">
                                {participants && participants?.length > 1 ?
                                    <Form.Control required as="select" className="form-select participant" onChange={selectParticipantHandler} value={JSON.stringify(selectedParticipant) || ""} >
                                        { participants.map( participant => <option key={participant.key} value={JSON.stringify(participant.value)}>{participant.name}</option> ) }
                                    </Form.Control>
                                : 
                                    <span>{selectedParticipant?.first_name + " " + selectedParticipant?.last_name + " (Me)"}</span>}
                            </Form.Group>
                            :
                            <span>Loading Family ...</span>
                        }
                        {typeof(selectedParticipant?.allowed) === "string" &&
                            <span className="error-text">{selectedParticipant.allowed}</span>
                        }
                    </Col>
                </Row>
                {customFields && customFields?.length>0 &&
                    <h5 className="dash-title pt-3">Registration Questions</h5>
                }
                <Row>
                   
                    <CustomResponseFields 
                        eventId={eventID} 
                        //we do no user id because we aren't editing
                        submit={false}
                        validationFunction={customFieldValidationHandler}
                    />

                </Row>
                <Row>
                    <Col className="p-0 col-auto">   
                        <Button variant="light" href={`/p/event-register${props.event_parent_id ? "?event=" + props.event_parent_id : ""}`} className="gray-b-btn">Back</Button>
                    </Col>
                    <Col className="p-0 col-auto">   
                        <Button type="submit" disabled={disabled} className={`orange-btn${submitting?" submitting":""}`} data-cy="event-page-register-btn">Register</Button>  
                    </Col>
                </Row>
            </Form>
            {typeof error !== 'string' && 
            <>
                {error}
            </>
            }{validationErrors?.length > 0 && submitting &&
                <ErrorCatcher error={validationErrors} onClose={()=>{setValidationErrors([]); setSubmitting(false)}} />
            }
        </div>
    );
}
